import React, { Component } from "react";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
import '../../OrganizationSetup.css';

const actions = (props) => {
    return (<Row className="mt40 upload_data_button_container">
        <Col sm={{ size: "6" }}>
          <Row>
            <Col sm="6">
              <Button
                className="float-left goBackBtn w100"
                onClick={props.goBack}>
                <span className="goBackBtnTxt">
                  <span className="ml10 flaticon-back"/> Go Back
            </span>
              </Button>
            </Col>
          </Row>
        </Col>
        <Col sm="6" md="6">
          <Row>
            <Col sm={{size: 6, offset: 6}} md={{size: 6, offset: 6}}>
              <Button className="float-right continueBtn w100" onClick={props.nextBtnAction}>
                <span className="continueBtnTxt">
                  {props.nextBtnTxt} 
                  <span className={ 'ml10 '.concat(props.nxtBtnIcon)} />
                </span>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>)
}

export default actions;